import { API, deleteRequest, getRequest } from '@/api/api.ts';
import type { ContactsResponse } from '@/store/contacts/contacts.dto.ts';

export const getContacts = async () => {
  return await getRequest<ContactsResponse>(API.PEOPLE, 'contact-list?limit=1000&page=1');
};

export const removeContact = async (id: string) => {
  await deleteRequest<ContactsResponse>(API.PEOPLE, `contact-list/${id}`);
};
